<template>
  <Modal :id="'cpm-add-release-related-product'" @cancelled="onCancel">
    <template slot="header">{{$t('new_product')}}</template>

    <template slot="body">
      <!-- <span>c{{ company }} p{{ person }}</span> -->

      <div class="ut-flex" style="align-items: stretch;">
        <div style="flex: 1;">
          <TextField
            class="m1"
            :id="'alt_title'"
            
            v-bind="textFieldConfig2"
            :value="alt_title"
            :placeholder="$t('alt_title')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          />
          <TextField
            class="m1"
            :id="'alt_artist'"
            
            v-bind="textFieldConfig2"
            :value="alt_artist"
            :placeholder="$t('alt_artist')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          />
          <TextField
            class="m1"
            :id="'catalog_no'"
            required
            v-bind="textFieldConfig"
            :value="catalog_no"
            :placeholder="$t('catalog_no')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          />
          <TextField
            class="m1"
            :id="'barcode'"
            
            v-bind="textFieldConfig2"
            :value="barcode"
            :placeholder="$t('barcode')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          />
          <Dropdown
            :options="formatsTV"
            class="group-input m2"
            :key="'group_dropdown_company'"
            :placeholder="$t('format')"
            v-on:selectedChange="(e) => onFormatChange(e)"
            :selected="formatsTV.find(e=>e.value==formatId)"
            box            
            :listHeight="250"
            :showValidationIcons="true"
            :immediateValidation="true"
            required
            @validated="e => onValidation('formatId', e)"
          />
          <TextField
            type="date"
            id="product_date"
            class="m1"
            :placeholder="$t('product_date')"
            :value="product_date"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
        <!-- ut-my-10px ut-mx-4px -->
        <div style="flex: 1;margin-left: 35px;">
          <div class="ut-flex ">
            {{$t('copy_tracks_from')}} :
          </div>
          <div  class="radio-group-selection">
            <template v-for="(item,index) in relatedProducts">
              <div class="radio-item"  :key="index">
                <input
                  type="radio"
                  @change="(e) => onRadioChange(item)"
                  :checked="isRelatedProduct(item)"
                  name="product"
                />
                <label
                  for="product"
                  @click="(e) => onRadioChange(item)"
                >
                  {{ item.catalog_no||'' }} &nbsp; {{ item.barcode	||'' }} &nbsp; {{ item.format_name	||'' }}
                </label>
              </div>
            </template>
        
          </div>
        </div>
      </div>

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        style="max-width: 150px;"
        
        @click.stop="addNewProduct"
      >
        {{$t('add_related_product')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";



import Modal from "@/dt-plugins/modal/modal";
import { tv } from "../../../../models/text-value.model";
import { releaseService } from '../../services/releases/releases.services';
import { format } from 'date-fns';
export default {
  components: {
    Modal
  
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      textFieldConfig2: {
        height: 42,
        showEditIconOnHover: false,
        box: true,

      },

      loading: true,
      formats:[],
      relatedProducts:[],
      relatedProductId:0,
      formatId:0,
      catalog_no:'',
      barcode:'',
      alt_artist:'',
      alt_title:'',
      product_date:'',
      validationResult: {},

      
    };
  },
  mounted:async function () {
      const resData=await releaseService.addRelatedProductForm(this.external_id);
      console.log("RES DATA",resData);
      this.formats=resData.data.formats;
      this.relatedProducts=resData.data.related_products

  },
  computed: {
    external_id: function() {
      return this.$route.query.external_id;
    },
    formatsTV:function(){
      return this.formats.map(tv('format_name','format_id'))||[]
    },

    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }

 
  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange: function (key, value) {
      console.log("KEY,VALUE",key,value)
      // if(key=="CatalogNo"){
      //   this.catalog_no=value
      // }
      // else{
      //   this.barcode=value
      // }

      this[key] =value



    },


    onCancel: function () {
      this.$emit("cancelled", true);
    },

    addNewProduct: function (e) {
      const payload={ 
                      format_id:this.formatId,
                      related_product_id:this.relatedProductId,
                      catalog_no:this.catalog_no,
                      barcode:this.barcode,
                      alt_artist:this.alt_artist,
                      alt_title:this.alt_title,
                      product_date:this.product_date
                    };
      
      this.$emit("create",payload)

    },
    onRadioChange: function (item) {
      console.log("TYPE",item)
      this.relatedProductId=item.product_id
      //this.formatId=item.format_id
    },
    onFormatChange: function (value) {
      console.log("VALUE",value)
      this.formatId=value.value
    },
    isRelatedProduct: function (item) {
      return item.product_id === this.relatedProductId
    },
    //MARK: Methods
  },
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group = [],
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group,
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  group = [],
} = {}) => {
  return {
    companyName,
    city,
    country,
    group,
  };
};
</script>

<style lang="scss">
.cpm-add-release-related-product {
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }

    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .person-controls,
  .company-controls {
    height: 249px;
  }

  .radio-group-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;

    max-height: 200px;
    overflow: auto;

    .radio-item {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
